import { DocumentoVO } from "./documentoVO";

export class DatiPagamentoVO {
    dataPagamento: string;
    quietanzaPagamento: DocumentoVO;
}